<template>
    <div class="centerPage">
        <div class="search flex">
            <span class="tit">咨询管理</span>
            <div class="flex">
                <el-input placeholder="姓名" clearable v-model="searchCondition.realName"
                          @change="changeName()"></el-input>
                <!--<el-input placeholder="手机号码" clearable v-model="tel"></el-input>-->
                <el-button size="mini">搜索</el-button>
            </div>
        </div>
        <div class="border">
            <el-table
                    v-if="medicalRecordData!=0"
                    class="record-table"
                    :data="medicalRecordData"
                    :header-cell-style="{'background':'rgba(86,123,255,0.1)','color': '#666','fontWeight':'400','textAlign':'center'}"
                    height="calc(100vh - 357px)">
                <el-table-column label="编号" prop="medicalNo" align="center" width="160"></el-table-column>
                <el-table-column label="姓名" prop="realName" align="center"></el-table-column>
                <!--<el-table-column prop="age" align="center" label="手机号码" width="120"></el-table-column>-->
                <!--<el-table-column label="所在城市" prop="age" align="center"></el-table-column>-->
                <el-table-column label="主要诉求" align="center" prop="medicalReason"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column label="时间" align="center" prop="medicalDate"></el-table-column>
                <el-table-column label="支付金额(元)" align="center" width="150">
                    <template slot-scope="scope">
                        <span class="disabled">{{scope.row.payAmount}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="咨询建议" align="center" width="150">
                    <template slot-scope="scope">
                        <el-button size="mini" class="detail"
                                   @click="$router.push({name:'recordDetail',query:{id: scope.row.medicalNo}})">详情
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="empty" v-else>
                <img src="../../assets/img/no.png" alt="" width="200">
                <p>这里什么都没有</p>
            </div>
            <el-pagination
                    class="pagination"
                    background
                    prev-text="Prev"
                    next-text="Next"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="page.current"
                    :page-size="page.size"
                    layout="prev, pager, next"
                    :total="page.total">
            </el-pagination>
        </div>

    </div>
</template>

<script>
    import base from '@/api/common';
    import commonjs from "../../api/common";

    export default {
        name: "medicalRecord",
        data() {
            return {
                // name: '',
                // tel: '',
                // patients: [],

                page: {
                    current: 1,
                    size: 9,
                    total: 0
                },//关于分页
                // doctorId: '',

                getMedicalRecordPageByDoctorUrl: commonjs.api.doctor.medicalRecord.pageByDoctor,//查找病历url
                medicalRecordData: [],//咨询数据
                searchCondition: {
                    realName: '',//真实姓名
                },//搜索条件
            }
        },
        methods: {
            // getData() {
            //     let vm = this;
            //     vm.$ajax.post(base.api.doctor.patients.replace('{did}', vm.doctorId)
            //         .replace('{pg}', vm.page.current)
            //         .replace('{ps}', vm.page.size))
            //         .then((res) => {
            //             if (res.data.status == 'success') {
            //                 vm.patients = res.data.data.records;
            //                 console.log(res.data.data)
            //             }
            //         })
            // },

            handleSizeChange(val) {
                this.page.size = val;
            },
            handleCurrentChange(val) {
                this.page.current = val;
                this.getMedicalRecordPageByDoctor();
            },
            //根据医生查找咨询
            getMedicalRecordPageByDoctor() {
                let that = this;
                this.$ajax
                    .post(that.getMedicalRecordPageByDoctorUrl.replace("{currentPage}/{pageSize}", that.page.current + "/" + that.page.size), that.searchCondition)
                    .then(function (res) {
                      if (res.data.status === 'success') {
                        that.page.total = res.data.total;
                        that.medicalRecordData = res.data.rows;
                      }
                    })
            },
            //搜索用户名字
            changeName() {
                this.getMedicalRecordPageByDoctor()
            },
        },
        async mounted() {
            // let currentUser = await base.utils.getCurrent();
            // if (currentUser) {
            //     this.doctorId = currentUser.id
            // }
            // this.getData();
            this.getMedicalRecordPageByDoctor();//根据医生查找咨询
            // this.$ajax.get('/data.json')
            //     .then((res) => {
            //         this.patient = res.data.patient
            //     })
        },
    }
</script>

<style scoped lang="scss">
@import '../../assets/css/patients.scss';

.blue {
    color: #567BFF;
}

.search div:first-child {
    width: 50%;
}

.orange {
    font-size: 13px;
    color: #FC7B66;
    margin-left: 5%;
}

.detail {
    border-color: #567BFF;
    color: #567BFF;
    background: #ffffff;

    &:hover, &:focus {
        color: #567BFF;
        border-color: #567BFF;
        background-color: #ffffff;
    }
}
</style>